import React from 'react';

import Button from '../../Button';
import Container from '../../Container';

import image from './home-campus@large.jpg';

import styles from './index.module.scss';

/* eslint-disable react/prop-types */
export default ({ locale }) => (
  <div className={styles.root} style={{ backgroundImage: `url(${image})` }}>
    <div className={styles.overlay} />
    <Container className={styles.text}>
      <p className={locale === 'zh' ? styles.zh : ''}>
        {locale === 'en' ? `Take the next step for your child` : `為你的孩子採取下一步`}
      </p>
      <Button color="#fff" external link to="http://admissions.kingston.edu.hk">
        {locale === 'en' ? `Apply Now` : `立即申請`}
      </Button>
    </Container>
  </div>
);
